module.exports = __webpack_public_path__ + "img/01.001ded79.svg";